import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import appConfig from 'app-config';
import SasriaEntryPageTemplate from '../EntryPage/template/SasriaEntryPageTemplate';
import { renderContentFromMetadata } from '@jutro/uiconfig'; 
import metadata from './UpdatePasswordPage.metadata.json5';
import { DynamicRoute, useAuthentication, withAuthContextProvider } from 'gw-digital-auth-react';

const { applicationDetails } = appConfig;
function UpdatePasswordPage(props) {

    const auth = useAuthentication();
    const oAuthConfig  = useAuthentication();

    const handleSignInClick = useCallback(() => {
        auth.logout(oAuthConfig);
    },[]);

    const resolvers = {
        resolveCallbackMap: {
            onSignInClick: handleSignInClick
        }
    };
    
    const overrideProps = {};
    
    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );
    return (
        <SasriaEntryPageTemplate
            applicationName={applicationDetails.applicationName}
            applicationLogo={applicationDetails.applicationLogo}
            contentToRender={renderedContentFromMetadata}
        />
    );
}

UpdatePasswordPage.propTypes = {
    onBackToSignIn: PropTypes.func
};

export default UpdatePasswordPage;